const getCodeFromUrl = () => {
    const url_string = window.location.href
    const url = new URL(url_string);
    const code = url.searchParams.get("code");

    return code;
};

const piecesURL = __myapp.env.REQUESTS_BASE_URL;

export const getPieces = async () => {
    const code = getCodeFromUrl();

    const response = await fetch(
        `${piecesURL}/pieces/` ,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${code}`,
            },
        }
    );

    if (!response.ok) {
        throw new Error(`Error when accessing data ${response}`);
    }

    return response.json();
};


export const postSelectedData = async (data) => {
    const code = getCodeFromUrl();

    const response = await fetch(
        `${piecesURL}/pieces/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${code}`,
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error(`Error when accessing data at ${response}`);
    }
};
